import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function myAppLaunch({ uid, name }) {
  pushClevertapEvent('Apps Launch', {
    'App Name': name,
    'App ID': uid,
  });
}

export function myAppRevoke({ uid, name }) {
  pushClevertapEvent('Apps Revoke', {
    'App Name': name,
    'App ID': uid,
  });
}

export function myAppRevokeCancel() {
  pushClevertapEvent('Apps Revoke Cancel');
}

export function myAppRevokeConfirmed({ uid, name }) {
  pushClevertapEvent('Apps Revoke Confirmed', {
    'App Name': name,
    'App ID': uid,
  });
}

export function myAppRevokeClosed() {
  pushClevertapEvent('Apps Revoke Closed');
}

export function myAppLink() {
  pushClevertapEvent('Apps My Apps Link', {});
}

export function myActiveAppList(activeApps) {
  clevertap.profile.push({
    Site: {
      'Active Applications': activeApps,
    },
  });
}
